import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import { Button, InputLabel } from "@mui/material";
import { getDisputeStatusDesign } from "../../../../utils/getDisputeStatusDesign";
import store from "../../../../assets/shopify.png";
import styles from "../../../../styles/customerStyles.module.css";
import StatusBadge from "../../../../../../components/StatusBadge";
import { isClientPreview } from "../../../../../../utils/clientPreview";
import ChinaWarehouseDetails from "../../../../../admin/pages/bulkPurchase/components/ChinaWarehouseDetails";

// Reply: our team answered, so the merchant should read it. Waiting: with our team.
const disputeBadge = (value) => {
  if (value?.status === "returned") return { label: "Awaiting carrier", tone: "violet" };
  if (value?.status === "complete") return { label: "Complete", tone: "success" };
  if (value?.status === "archived") return { label: "Archived", tone: "neutral" };
  if (value?.conversationStatus === "Reply") return { label: "Reply", tone: "attention" };
  if (value?.conversationStatus === "Waiting" || value?.conversationStatus === "pending") return { label: "Waiting", tone: "info" };
  return { label: value?.status || "Open", tone: "neutral" };
};

export default function DisputeDetailsModal({ value, background, hoverBG, returnedOrder }) {

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const badge = disputeBadge(value);
  return (
    <>
      {isClientPreview() ? (
        <StatusBadge tone={badge.tone} onClick={returnedOrder ? undefined : handleOpen} title="Open dispute">
          {badge.label}
        </StatusBadge>
      ) : (
      <Button
        variant="deepbluemini"
        onClick={() =>{
          if(!returnedOrder){
            handleOpen()
          }
        }}
        sx={{
          background:
          value?.status === 'returned' ? '#FFF0F0': value.conversationStatus === "Waiting"
              ? "#EAE8ED"
              : value?.status === "complete" ||
                value.conversationStatus === "Reply"
              ? `${background}`
              : `${background}`,
          color:
          value?.status === 'returned' ? '#FF1818': value.conversationStatus === "Waiting"
          ? "#a2a2a2": value?.status === "complete" || value.conversationStatus === "Reply"
              ? "#5833A9"
              : value.status === "archived" ? "green" 
              
              : "#1A3AB8",
          fontSize: "14px",
          fontWeight: 700,
          padding: "8px 20px",
          width: "45%",
          borderRadius: "8px",
          margin: 0,
          height: "auto",
          ":hover": {
            background: `${hoverBG}`,
          },
          boxShadow: "none",
          // pointerEvents: (value.conversationStatus === "Reply" || value.conversationStatus === "Waiting") ? 'none':''
        }}
      >
        {value?.status === 'returned' ? 'Awaiting' :value?.status === "complete"
          ? value.status
          : value.conversationStatus === "Waiting" ||
            value.conversationStatus === "pending"
          ? "Waiting"
          : value.conversationStatus === "Reply"
          ? "Reply"
          : value.status}
      </Button>
      )}

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box
            sx={{
              bgcolor: "background.paper",
              boxShadow: 24,
              width: value.status === "POD" ? "40%" : "20%",
              borderRadius: "14px",
              padding: value.status === "POD" ? "20px 100px" : "0",
            }}
            className={styles.dispute_details_modal}
          >
            <div>
              {value.status === "POD" ? (
                <div>
                  <img
                    src={store}
                    alt=""
                    style={{
                      width: "40px",
                      height: "40px",
                      marginBottom: "20px",
                    }}
                  />
                  <div className="flexbox" style={{ color: "black" }}>
                    <div className={styles.text_left}>
                      <h6>Order ID</h6>
                      <strong style={{ fontSize: "14px" }}>#001703</strong>
                    </div>
                    <div className={styles.text_left}>
                      <h6>Date</h6>
                      <strong style={{ fontSize: "14px" }}>30-07-22</strong>
                    </div>
                    <div className={styles.text_left}>
                      <h6>Customer name</h6>
                      <strong style={{ fontSize: "14px" }}>
                        Pattrick Leach
                      </strong>
                    </div>

                    <div className={styles.text_left}>
                      <h6>Dispute status</h6>
                      {getDisputeStatusDesign({
                        value: "Completed",
                        details: true,
                      })}
                    </div>
                  </div>
                  <div style={{ marginTop: "20px" }}>
                    <ChinaWarehouseDetails title="details" />
                  </div>

                  <Button
                    variant="deepblue"
                    sx={{ width: "auto" }}
                    onClick={handleClose}
                  >
                    Download
                  </Button>
                </div>
              ) : (
                <div>
                  <div
                    style={{
                      display: "flex",
                      justifyItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginRight: "5px",
                      }}
                    >
                      <img
                        src={store}
                        alt=""
                        style={{
                          width: "18px",
                          height: "18px",
                          marginTop: "10px",
                        }}
                      />
                    </div>
                    <h4
                      style={{
                        fontSize: 14,
                        marginTop: "10px",
                      }}
                    >
                      Dispute{" "}
                      {value?.status === "complete" ? "completed" : "pending"} -
                      Order {`#${value?.order?.shopify_order_number}`}
                    </h4>
                  </div>
                  <div style={{ textAlign: "left", padding: "10px 20px" }}>
                    <InputLabel sx={{ fontWeight: 600 }}>
                      Dispute Issue:
                    </InputLabel>
                    <p>{value?.issue}</p>
                    <InputLabel sx={{ fontWeight: 600 }}>
                      Desire Outcome:
                    </InputLabel>
                    <p>{value?.outcome?.map((item) => item + ", ")}</p>
                    <InputLabel sx={{ fontWeight: 600 }}>
                      Attachments:
                    </InputLabel>
                    <p
                      style={{
                        textDecoration: "underline",
                        fontWeight: "bold",
                      }}
                    >
                      {value?.dispute_files?.map((file, i) => (
                        <a
                          href={file}
                          target="_blank"
                          rel="noreferrer"
                          download="dispute"
                          style={{marginRight:"8px"}}
                        >
                          #{i + 1} File
                        </a>
                      ))}
                    </p>
                    <InputLabel sx={{ fontWeight: 600, marginBottom:0 }}>
                      Additional Information:
                    </InputLabel>
                    <p> {value?.additional_notes ||"Not available"} </p>
                    <InputLabel sx={{ fontWeight: 600, marginBottom:0 }}>
                      Dispute Response:
                    </InputLabel>
                   <p> {value?.response?.feedback ||"Not available"} </p>
                  {value?.response?.refunded_amount && <p> Refunded: <strong style={{fontWeight:600}}>€{value?.response?.refunded_amount}</strong> </p>}
                   <p
                      style={{
                        textDecoration: "underline",
                        fontWeight: "bold",
                      }}
                    >
                      {value?.response?.files?.map((file, i) => (
                        <a
                          href={file}
                          target="_blank"
                          rel="noreferrer"
                          download="dispute"
                          style={{marginRight:"5px"}}
                        >
                          #{i + 1} File
                        </a>
                      ))}
                    </p>
                  </div>
                  <div style={{ textAlign: "right" }}>
                    <Button
                      variant="purple"
                      sx={{
                        width: "auto",
                      }}
                      onClick={handleClose}
                    >
                      Close
                    </Button>
                  </div>
                </div>
              )}
            </div>

            {/* <Button variant="deepblue">Close</Button> */}
          </Box>
        </Fade>
      </Modal>
    </>
  );
}
